import React from "react";

const TodoCard = ({ goal, purpose, todo, timing, onDelete }) => {
  return (
    <>
      <div className="d-flex justify-content-start flex-row"> {/* 確保是水平排列 */}
        <div className="card mb-1 mr-3" style={{ minWidth: "200px" }}> {/* 調整卡片最小寬度 */}
          <div className="card-body">
            <div className="d-flex align-items-center mb-1">
              <div>
                <h5 className="card-title m-0 mr-2">Goal: {goal}</h5>
                <div className="card-text">Purpose: {purpose}</div>
                <div className="card-text">Todo: {todo}</div>
              </div>
            </div>
            <p className="card-text text-center">--Timing: {timing}--</p>
          </div>
          <button onClick={onDelete} className="btn btn-outline-danger">Del</button>
        </div>
      </div>
    </>
  );
};

export default TodoCard;
